// extracted by mini-css-extract-plugin
module.exports = {"member":"style_member__2VSUk","name":"style_name__3o6Zm","pic":"style_pic__1Mosx","contact":"style_contact__1ziAl","link":"style_link__EyePD","blurb":"style_blurb__34Wmo"};